import { render } from "./TextAreaWithClear.vue?vue&type=template&id=04ac4010&scoped=true&ts=true"
import script from "./TextAreaWithClear.vue?vue&type=script&lang=ts"
export * from "./TextAreaWithClear.vue?vue&type=script&lang=ts"

import "./TextAreaWithClear.vue?vue&type=style&index=0&id=04ac4010&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ac4010"]])

export default __exports__